import { AncillaryBaggageInfo, MealInfo, SeatPriceMap } from '@/src/types/itinerary'

const isMealSelected = (meal: MealInfo, selectedMealOptions: Partial<MealInfo>[]) => {
    const quantity = selectedMealOptions.filter(selectedMeal => selectedMeal.code === meal.code).length
    return { quantity, isSelected: quantity > 0 }
}

const isBaggageSelected = (baggage: AncillaryBaggageInfo, selectedBaggageOptions: AncillaryBaggageInfo[]) => {
    const quantity = selectedBaggageOptions.filter(
        selectedBaggage => selectedBaggage.baggageCode === baggage.baggageCode
    ).length
    return { quantity, isSelected: quantity > 0 }
}

const getSeatType = (seatCharacteristics: string[]) => {
    if (seatCharacteristics.includes('WINDOW')) {
        return 'Window Seat'
    }
    if (seatCharacteristics.includes('AISLE')) {
        return 'Aisle Seat'
    }
    if (seatCharacteristics.includes('MIDDLE')) {
        return 'Middle Seat'
    }
    return ''
}

const getSeatColor = (price: number, seatPriceMap: SeatPriceMap[]) => {
    const { seatColor } = seatPriceMap.find(seat => seat.start <= price && seat.end >= price) || {}
    return seatColor || 'seatColors.unavailable'
}

export { getSeatColor, getSeatType, isBaggageSelected, isMealSelected }
